import { createStore } from "vuex";

/*

Beaker/electrode changes
---------------------------

buildup: build up appears on electrode over time

weardown: electrode wears away over time

builduplessblue:  build up appears on electrode over time and solution becomes less blue over time

weardownmoreblue: electrode wears away over time and solution becomes brighter blue over time

bubbles (change): Hydrogen gas bubbles are pumped into the solution from the opening on the upper part of the hydrogen electrode. 
Bubbles disappear after they come into contact with the platinum metal on the interior of the electrode set up

bubbles2 (change): Hydrogen gas bubbles are formed on the surface of the platinum on the interior of the electrode set up and 
bubble up to the surface of the beaker

Zoom animations
---------------------------

buildup2e2a: Two electrons come down the surface of the electrode from off screen and transfer on to two + ions from solution 
(one e- goes to each ion) when the ions approach the surface of the electrode. Ions become neutral and stick to surface of the
electrode. (Ions are smaller than neutral atoms by ~40%). Repeat ~2-3 times.

buildup2e1a: Two electrons come down the surface of the electrode from off screen and transfer on to one + ion from solution 
when the ion approaches the surface of the electrode. Ion becomes neutral and sticks to surface of the electrode. 
(Ions are smaller than neutral atoms by ~40%). Repeat ~2-3 times.

down1a2e: One neutral atom from the surface of the electrode loses 2 electrons and becomes a 2+ ion and floats off in the 
solution (~40% smaller than the original neutral atom). The electrons move up the electrode and off screen. Repeat ~2-3 times.

bubbles (zoom): H2 molecules come down in the solution from top of screen. At the same time, two electrons run down the the 
surface of the platinum atoms on the interior of the electrode set up. When the H2 molecules in the solution come into contact
w/ platinum atoms, one of the electrons transfers to each hydrogen atom. The H2 molecule then breaks apart and two H+ ions float
off into solution. Repeat ~2-3 times.

bubbles2 (zoom): Two H+ ions come into contact with platinum metal. Two electrons come down the surface of the platinum metal from off 
screen and each one transfers on to one of the H+ ions. The two hydrogens (now neutral) combine into an H2 molecule. 
(This will look similar to the animation from Activity 4 in the previous simulation except there will be no metal ions coming 
off the surface of the platinum. The metal atoms will remain the same.)


*/

export default createStore({
  state: {
    sets:[
      {
        id: 0,
        metal: 'Ag',
        name: "Silver (Ag) in AgNO<sub>3</sub> (aq)",
        startJuice: '#c4ccdd',
        rod: 'silver.png',
        results: {
          Cu: {
            voltage: '+ 0.46',
            juice: '#c4ccdd',
            oneChange: 'buildup',
            twoChange: 'weardownmoreblue',
            oneZoom: 'buildup2e2a',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'
          },
          HCl: {
            voltage: '+ 0.80',
            juice: "#c4ccdd",
            oneChange: 'buildup',
            twoChange: 'bubbles',
            oneZoom: 'buildup2e2a',
            twoZoom: 'bubbles',
            saltZoom: 'moveLeft'
          },
          Zn:{
            voltage: "+ 1.56",
            juice: "#c4ccdd",
            oneChange: 'buildup',
            twoChange: 'weardown',
            oneZoom: 'buildup2e2a',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'
          },
          Mg:{
            voltage: "+ 3.18",
            juice: "#c4ccdd",
            oneChange: 'buildup',
            twoChange: 'weardown',
            oneZoom: 'buildup2e2a',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'
          },
        }
      },
      {
        id: 1,
        metal: 'Cu',
        name: "Copper (Cu) in Cu(NO<sub>3</sub>)<sub>2</sub> (aq)",
        startJuice: '#96b3f7',
        rod: 'copper.png',
        results: {
          Ag: {
            voltage: '- 0.46',
            juice: 'blue',
            oneChange: 'weardownmoreblue',
            twoChange: 'buildup',
            oneZoom: 'down1a2e',
            twoZoom: 'buildup2e2a',
            saltZoom: 'moveRight'
          },
          HCl: {
            voltage: '+ 0.34',
            juice: "#b1c5f2",
            oneChange: 'builduplessblue',
            twoChange: 'bubbles',
            oneZoom: 'buildup2e1a',
            twoZoom: 'bubbles',
            saltZoom: 'moveLeft'
          },
          Zn:{
            voltage: "+ 1.10",
            juice: "#b1c5f2",
            oneChange: 'builduplessblue',
            twoChange: 'weardown',
            oneZoom: 'buildup2e1a',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'            
          },
          Mg:{
            voltage: "+ 2.72",
            juice: "#c4ccdd",
            oneChange: 'builduplessblue',
            twoChange: 'weardown',
            oneZoom: 'buildup2e1a',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'            
          },
        }
      },
      {
        id: 2,
        metal: 'Zn',
        name: "Zinc (Zn) in Zn(NO<sub>3</sub>)<sub>2</sub> (aq)",
        startJuice: '#c4ccdd',
        rod: 'zinc.png',
        results: {
          Ag: {
            voltage: '- 1.56',
            juice: '#c4ccdd',
            oneChange: 'weardown',
            twoChange: 'buildup',
            oneZoom: 'down1a2e',
            twoZoom: 'buildup2e2a',
            saltZoom: 'moveRight'
          },
          Cu: {
            voltage: '- 1.10',
            juice: '#c4ccdd',
            oneChange: 'weardown',
            twoChange: 'builduplessblue',
            oneZoom: 'down1a2e',
            twoZoom: 'buildup2e1a',
            saltZoom: 'moveRight'
          },
          HCl: {
            voltage: '- 0.76',
            juice: '#c4ccdd',
            oneChange: 'weardown',
            twoChange: 'bubbles2',
            oneZoom: 'down1a2e',
            twoZoom: 'bubbles2',
            saltZoom: 'moveRight'
          },
          Mg: {
            voltage: '+ 1.62',
            juice: '#c4ccdd',
            oneChange: 'buildup',
            twoChange: 'weardown',
            oneZoom: 'buildup2e1a',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'
          },
        }
      },
      {
        id: 3,
        metal: 'HCl',
        name: "Hydrogen Electrode in HCl (aq)",
        startJuice: '#c4ccdd',
        rod: 'hydrogen-electrode.png',
        results: {
          Ag: {
            voltage: '- 0.80',
            juice: '#c4ccdd',
            oneChange: 'bubbles',
            twoChange: 'buildup',
            oneZoom: 'bubbles',
            twoZoom: 'buildup2e2a',
            saltZoom: 'moveRight'
          },
          Cu: {
            voltage: '- 0.34',
            juice: '#c4ccdd',
            oneChange: 'bubbles',
            twoChange: 'builduplessblue',
            oneZoom: 'bubbles',
            twoZoom: 'buildup2e1a',
            saltZoom: 'moveRight'
          },
          Zn: {
            voltage: '+ 0.76',
            juice: '#c4ccdd',
            oneChange: 'bubbles2',
            twoChange: 'weardown',
            oneZoom: 'bubbles2',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'
          },
          Mg: {
            voltage: '+ 2.38',
            juice: '#c4ccdd',
            oneChange: 'bubbles2',
            twoChange: 'weardown',
            oneZoom: 'bubbles2',
            twoZoom: 'down1a2e',
            saltZoom: 'moveLeft'
          },
        }
      },
      {
        id: 4,
        metal: 'Mg',
        name: "Magnesium (Mg) in Mg(NO<sub>3</sub>)<sub>2</sub> (aq)",
        startJuice: '#c4ccdd',
        rod: 'magnesium.png',
        results: {
          Ag: {
            voltage: '- 3.18',
            juice: '#c4ccdd',
            oneChange: 'weardown',
            twoChange: 'buildup',
            oneZoom: 'down1a2e',
            twoZoom: 'buildup2e2a',
            saltZoom: 'moveRight'            
          },
          Cu: {
            voltage: '- 2.72',
            juice: '#c4ccdd',
            oneChange: 'weardown',
            twoChange: 'builduplessblue',
            oneZoom: 'down1a2e',
            twoZoom: 'buildup2e1a',
            saltZoom: 'moveRight'            
          },
          HCl: {
            voltage: '- 2.38',
            juice: '#c4ccdd',
            oneChange: 'weardown',
            twoChange: 'bubbles2',
            oneZoom: 'down1a2e',
            twoZoom: 'bubbles2',
            saltZoom: 'moveRight'            
          },
          Zn: {
            voltage: '- 1.62',
            juice: '#c4ccdd',
            oneChange: 'weardown',
            twoChange: 'buildup',
            oneZoom: 'down1a2e',
            twoZoom: 'buildup2e1a',
            saltZoom: 'moveRight'            
          }
        }
      },      
    ],
    beakerOne: '',
    beakerTwo: '',
    voltageOn: false,
    beakerOnePos: {},
    beakerTwoPos: {},
  },
  getters: {
    getBeakerOne: (state) => state.beakerOne !== '' ? state.sets[state.beakerOne].startJuice : '#DADDE6',
    getBeakerTwo: (state) => state.beakerTwo !== '' ? state.sets[state.beakerTwo].startJuice : '#DADDE6',
    getSetOne: (state) => state.beakerOne !== '' ? state.sets[state.beakerOne] : null,
    getSetTwo: (state) => state.beakerTwo !== '' ? state.sets[state.beakerTwo] : null,
    getBothFormulas: state => {
      const formulas = {}

      formulas.left = state.beakerOne !== '' ? state.sets[state.beakerOne].name : ''
      formulas.right = state.beakerTwo !== '' ? state.sets[state.beakerTwo].name : ''

      return formulas
    },
    getBothMetals: state => {
      const metals = {}
      metals.one = state.beakerOne !== '' ? state.sets[state.beakerOne].metal : ''
      metals.two = state.beakerOne !== '' ? state.sets[state.beakerTwo].metal : ''
      return metals;
    },
    getVoltage: state => {
      let voltage = '0.00';
      if(state.beakerOne !== '' && state.beakerTwo !== '') {
        voltage = state.sets[state.beakerOne].results[ state.sets[state.beakerTwo].metal ].voltage
      }
      return voltage;
    },
    getBeakerStuff: state => {

      let stuff = false;

      if(state.beakerOne !== '' && state.beakerTwo !== '') {
        let r = state.sets[state.beakerOne].results;
        stuff = r[ state.sets[state.beakerTwo].metal ];
      }

      return stuff;
    }

  },
  mutations: {
    setBeakerOne: (state, i) => state.beakerOne = i,
    setBeakerTwo: (state, i) => state.beakerTwo = i,
    toggleVoltage: (state) => state.voltageOn = !state.voltageOn,
    fullReset: state => {
      state.beakerOne = ''
      state.beakerTwo = ''
      state.voltageOn = false
    },
    setBeakerOnePos: (state, pos) => state.beakerOnePos = pos,
    setBeakerTwoPos: (state, pos) => state.beakerTwoPos = pos,
  },
  actions: {},
  modules: {},
});
